import React, { useState, useMemo } from 'react';
import { useAuth } from '../contexts/AuthContext';
import './Login.css';
// Import background images
import canyonsImage from '../images/DSC_1070-8.jpg';
// Add more images here as you add them:
import aptosImage from '../images/A7408266-9.jpg';
import missionImage from '../images/A7408667-100.jpg';
import salinasImage from '../images/DSC_4514-27.jpg';
import redwoodImage from '../images/DSC_1167-19.jpg';
import winchesterImage from '../images/A7400168-8.jpg';

// Array of background images - add more images here
const backgroundImages = [
  canyonsImage,
  aptosImage,
  missionImage,
  salinasImage,
  redwoodImage,
  winchesterImage
];

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();

  // Randomly select an image on component mount (stable across re-renders)
  const selectedImage = useMemo(() => {
    const randomIndex = Math.floor(Math.random() * backgroundImages.length);
    return backgroundImages[randomIndex];
  }, []); // Empty dependency array means this only runs once on mount

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const result = await login(username, password);
      if (!result.success) {
        setError(result.error);
      }
    } catch (err) {
      setError('An unexpected error occurred');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container" style={{ backgroundImage: `url(${selectedImage})` }}>
      <div className="login-box">
        <h1>RSBBQ Toast Inventory Dashboard</h1>

        {error && <div className="error-message">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="username">Username</label>
            <input
              type="text"
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              autoComplete="username"
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              autoComplete="current-password"
            />
          </div>

          <button type="submit" disabled={loading} className="submit-button">
            {loading ? 'Please wait...' : 'Login'}
          </button>
        </form>

        <div className="login-note">
          <p>Need access? Contact your administrator.</p>
        </div>
      </div>
    </div>
  );
};

export default Login;
